import { text } from '@/config/theme';

export function Loader({ size = 'md', text: loadingText }: { size?: 'sm' | 'md' | 'lg'; text?: string }): JSX.Element {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className="flex flex-col items-center justify-center" role="status" aria-live="polite">
      <svg
        className={`animate-spin ${sizeClasses[size]} text-primary-600`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {loadingText !== undefined && (
        <p className={`mt-2 text-sm ${text.secondary}`}>{loadingText}</p>
      )}
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export function SkeletonLoader({ rows = 3 }: { rows?: number }): JSX.Element {
  return (
    <div className="animate-pulse space-y-4" role="status" aria-live="polite">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      ))}
      <span className="sr-only">Loading content...</span>
    </div>
  );
}
